import { Lxg } from "./lxg/Lxg"
import { LxgW } from "./lxg/LxgW"
import * as copyUtils from "@/minixs/CopyUtils"
import { Constant } from "@/minixs/Constant"
import * as duanYouApi from "../api/DuanYouApi"

export const BaseSect = {
    mixins: [Constant],
    data() {
        return {
            // 基础门派
            sectBase: {
                base: {
                    name: "凌雪阁"
                },
                // 原始属性
                originAttribute: {
                    atMaxLifeBase: 160878,
                    atVitalityBase: 45,
                    atAgilityBase: 44,
                    atStrengthBase: 44,
                    atPhysicsAttackPowerBase: 0,
                    atPhysicsCriticalStrike: 0,
                    atPhysicsCriticalDamagePowerBase: 0,
                    atPhysicsCriticalDamagePowerBaseKiloNumRate: 175.00,
                    atPhysicsOvercomeBase: 0,
                    atStrainBase: 0,
                    atHasteBase: 0,
                    atPVXAllRound: 0,
                    atSurplusValueBase: 0,
                    atMeleeWeaponDamageBase: 0,
                    atMeleeWeaponDamageRand: 0,
                },
                // 当前属性
                currentAttribute: {
                    atMaxLifeBase: 0,
                    atVitalityBase: 0,
                    atAgilityBase: 0,
                    atStrengthBase: 0,
                    atPhysicsAttackPowerBase: 0,
                    atPhysicsCriticalStrike: 0,
                    atPhysicsCriticalDamagePowerBase: 0,
                    atPhysicsCriticalDamagePowerBaseKiloNumRate: 175.00,
                    atPhysicsOvercomeBase: 0,
                    atStrainBase: 0,
                    atHasteBase: 0,
                    atPVXAllRound: 0,
                    atSurplusValueBase: 0,
                    atMeleeWeaponDamageBase: 0,
                    atMeleeWeaponDamageRand: 0,
                },
                // 最终属性
                finalAttribute: {
                    atMaxLifeBase: 0,
                    atVitalityBase: 0,
                    atAgilityBase: 0,
                    atStrengthBase: 0,
                    atPhysicsAttackPowerBase: 0,
                    atPhysicsCriticalStrike: 0,
                    atPhysicsCriticalDamagePowerBase: 0,
                    atPhysicsCriticalDamagePowerBaseKiloNumRate: 175.00,
                    atPhysicsOvercomeBase: 0,
                    atStrainBase: 0,
                    atHasteBase: 0,
                    atPVXAllRound: 0,
                    atSurplusValueBase: 0,
                    atMeleeWeaponDamageBase: 0,
                    atMeleeWeaponDamageRand: 0,
                    nEquipScore: 0,
                },
                coefficient: {
                    // 转化系数属性
                    agilityToPhysicsAttackPowerCof: 0,
                    agilityToPhysicsOvercomeCof: 0,
                },

                sectRecipe: {

                },
                sectLoop: {

                },
                // 配装属性
                peiZhuang: {
                    specialEffects:{
                        atSetEquipmentRecipe: [],
                        equipSkill: [],
                        atSkillEventHandler: [],
                        setMap: new Map(),
                    },
                }
            },
            // 门派实现
            sectImpl: {
                equipment: {
                },
                loop: {
                    loopTypeOptions: []
                },
                recipe: {

                },
                allBuff: {
                    income:{
                        
                    },
                    debuff:{
                        
                    }
                }

            }
        }
    },
    methods: {
        // 更换门派
        async changeSect(sectCode) {
            var sectImpl = (await this.selectSect(sectCode));
            this.sectImpl = sectImpl;
            await this.initSect(sectCode)
        },
        // 选择门派
        async selectSect(sectCode) {
            var sectImpl;
            if (Lxg.base.code == sectCode) {
                sectImpl = Lxg;
            } else if (LxgW.base.code == sectCode) {
                sectImpl = LxgW;
            } else {
                // 默认凌雪阁
                sectImpl = Lxg;
            }
            return sectImpl;
        },
        // 获取默认循环
        async getDefaultLoop() {
            return this.sectImpl.loop.loopTypeOptions[0];
        },
        // 初始化门派
        async initSect(sectCode) {
            await this.initSectAttribute();
            await this.initLoop(sectCode);
        },
        // 初始化门派属性
        async initSectAttribute() {
            copyUtils.copyMatchingFields(this.sectBase.originAttribute, this.sectBase.currentAttribute);
            copyUtils.copyMatchingFields(this.sectBase.originAttribute, this.sectBase.finalAttribute);
            // 同步心法属性
            for (let currentAttributeField in this.sectBase.currentAttribute) {
                for (let methodAttributeField in this.sectImpl.methodAttribute) {
                    if (currentAttributeField == methodAttributeField) {
                        this.sectBase.currentAttribute[currentAttributeField] += this.sectImpl.methodAttribute[methodAttributeField];
                    }
                }
            }
            // 同步系数影响
            for (let baseCoefficientField in this.sectBase.coefficient) {
                for (let implCoefficientField in this.sectImpl.coefficient) {
                    if (baseCoefficientField == implCoefficientField) {
                        this.sectBase.coefficient[baseCoefficientField] = this.sectImpl.coefficient[implCoefficientField];
                    }
                }
            }
        },
        // 初始化循环
        async initLoop(sectCode) {
            let req = {
                params : { sectCode: sectCode }
            }
            const { data:res } = await duanYouApi.getLoopBySectCode(req);
            this.sectImpl.loop.loopTypeOptions = res.data;
        },
        // 计算属性start
        async computePeiZhuangAttributeBYEquip(equip) { 
            // 添加基础和精炼属性
            var strengthLevel = equip.strengthLevel;
            if (equip.value == null || equip.value.equipOptionAttributeVoList == null) {
                return;
            }
            for (var equipAttribute of equip.value.equipOptionAttributeVoList) {
                var value = equipAttribute.value
                // 武器伤害不受精炼加成
                if (equipAttribute.code != "atMeleeWeaponDamageBase" && equipAttribute.code != "atMeleeWeaponDamageRand") {
                    value = Math.round(equipAttribute.value * this.peiZhuang.strengthLevelRate[strengthLevel]);
                }
                this.updateAttribute(equipAttribute.code, value);
            }
            // 添加镶嵌属性
            if (equip.value.equipOptionDiamondAttributeVoList != null) {
                for (var diamondAttribute of equip.value.equipOptionDiamondAttributeVoList) {
                    var value  = Math.floor(diamondAttribute.value * this.peiZhuang.diamondLevelRate[diamondAttribute.diamondLevel]);
                    this.updateAttribute(diamondAttribute.code, value);

                }
            }

            // 添加附魔属性
            if (equip.enchant1 != null && equip.enchant1.value != null) {
                var enchant1 = equip.enchant1.value;
                this.updateAttribute(enchant1.attributeCode, enchant1.attributeValue)
            }
            // 添加套装属性
            this.computeSet(equip);
            // 添加技能
            if (equip.value.allSkillIdList != null) {
                equip.value.allSkillIdList.forEach(t => this.sectBase.peiZhuang.specialEffects.equipSkill.push(t));
            }
        },
        // 更新属性
        updateAttribute(attribute, value) {
            if (!this.sectBase || !this.sectBase.currentAttribute) {
                throw new Error('sectBase or currentAttribute is undefined');
            }

            var valueNumber = Number(value);
        
            const Attribute = this.sectBase.currentAttribute;
        
            switch (attribute) {
                case 'atVitalityBase':
                case 'atAgilityBase':
                case 'atStrengthBase':
                case 'atPhysicsAttackPowerBase':
                case 'atPhysicsCriticalStrike':
                case 'atPhysicsCriticalDamagePowerBase':
                case 'atPhysicsOvercomeBase':
                case 'atStrainBase':
                case 'atSurplusValueBase':
                case 'atMeleeWeaponDamageBase':
                case 'atMeleeWeaponDamageRand':
                case 'atHasteBase':
                    Attribute[attribute] += valueNumber;
                    break;
                case 'atPVXAllRound':
                    Attribute.atPVXAllRound += valueNumber;
                    Attribute.atStrainBase += Math.floor(valueNumber * this.constant.atPVXAllRoundToStrain);
                    Attribute.atSurplusValueBase += Math.floor(valueNumber * this.constant.atPVXAllRoundToSurplus);
                    break;
                case 'atAllTypeCriticalDamagePowerBase':
                    Attribute.atPhysicsCriticalDamagePowerBase += valueNumber;
                    break;
                case 'atAllTypeCriticalStrike':
                    Attribute.atPhysicsCriticalStrike += valueNumber;
                    break;
                // 当类型为秘籍
                case 'atSetEquipmentRecipe':
                    this.sectBase.peiZhuang.specialEffects.atSetEquipmentRecipe.push(value.toString());
                    break;
                default:
                    // console.error(`Unknown attribute: ${attribute}`);
            }
        },
        computeSet(equip) {
            let setId = equip.value.setId;
            if (setId == null) {
                return;
            }
            let num = this.sectBase.peiZhuang.specialEffects.setMap.get(setId);
            if (num == null || num == 0) {
                num = 1;
                this.sectBase.peiZhuang.specialEffects.setMap.set(setId, num);
            } else {
                this.sectBase.peiZhuang.specialEffects.setMap.set(setId, ++num);
            }
            for (var set of equip.value.equipOptionSetVoList) {
                if (num == set.triggerLevel) {
                    var value = Number(set.value);
                    this.updateAttribute(set.code, value);
                    // 当套装有技能 同时添加套装技能
                    if (set.skillId != null) {
                        this.sectBase.peiZhuang.specialEffects.equipSkill.push(set.skillId);
                    }
                }
            }
        },
        async computeFinalAttribute() {
            // 最终主属性
            this.sectBase.finalAttribute.atVitalityBase = Math.floor(this.sectBase.currentAttribute.atVitalityBase);
            this.sectBase.finalAttribute.atAgilityBase = Math.floor(this.sectBase.currentAttribute.atAgilityBase);
            this.sectBase.finalAttribute.atStrengthBase = Math.floor(this.sectBase.currentAttribute.atStrengthBase);

            // 主属性转换属性
            // 基础破防
            this.sectBase.currentAttribute.atPhysicsOvercomeBase += Math.floor((this.sectBase.finalAttribute.atStrengthBase * this.constant.strengthToAtPhysicsOvercome));
            // 基础会心
            this.sectBase.currentAttribute.atPhysicsCriticalStrike += Math.floor((this.sectBase.finalAttribute.atAgilityBase * this.constant.agilityToAtPhysicsCriticalStrike));
            // 基础攻击
            this.sectBase.currentAttribute.atPhysicsAttackPowerBase += Math.floor((this.sectBase.finalAttribute.atStrengthBase * this.constant.strengthToAtPhysicsAttackPower));


            // 最终属性
            // 最终破防
            this.sectBase.finalAttribute.atPhysicsOvercomeBase = Math.floor((this.sectBase.currentAttribute.atAgilityBase * this.sectBase.coefficient.agilityToPhysicsOvercomeCof / 1024)) +
                this.sectBase.currentAttribute.atPhysicsOvercomeBase;
            // 最终会心
            this.sectBase.finalAttribute.atPhysicsCriticalStrike = this.sectBase.currentAttribute.atPhysicsCriticalStrike;
            // 最终会效
            this.sectBase.finalAttribute.atPhysicsCriticalDamagePowerBase = this.sectBase.currentAttribute.atPhysicsCriticalDamagePowerBase;

            // 最终攻击
            this.sectBase.finalAttribute.atPhysicsAttackPowerBase = Math.floor((this.sectBase.currentAttribute.atAgilityBase * this.sectBase.coefficient.agilityToPhysicsAttackPowerCof / 1024)) +
                this.sectBase.currentAttribute.atPhysicsAttackPowerBase;

            // 最终武器伤害
            this.sectBase.finalAttribute.atMeleeWeaponDamageBase = this.sectBase.currentAttribute.atMeleeWeaponDamageBase;
            this.sectBase.finalAttribute.atMeleeWeaponDamageRand = this.sectBase.currentAttribute.atMeleeWeaponDamageRand;
            // 最终破招
            this.sectBase.finalAttribute.atSurplusValueBase = this.sectBase.currentAttribute.atSurplusValueBase;
            // 最终加速
            this.sectBase.finalAttribute.atHasteBase = this.sectBase.currentAttribute.atHasteBase;
            // 最终无双
            this.sectBase.finalAttribute.atStrainBase = this.sectBase.currentAttribute.atStrainBase;
            // 最终生命上限
            this.sectBase.finalAttribute.atMaxLifeBase = this.sectBase.currentAttribute.atMaxLifeBase;


            this.sectBase.finalAttribute.atAgilityBase = Math.floor(this.sectBase.currentAttribute.atAgilityBase);

            // 最终百分比
            this.sectBase.finalAttribute.atMaxLifeBase = Math.floor((this.sectBase.finalAttribute.atVitalityBase * this.constant.vitalityMaxLifeRate + this.sectBase.finalAttribute.atMaxLifeBase) * (1 + Math.floor(Math.floor((14 + 10) / 100 * 1024)) / 1024));
            this.sectBase.finalAttribute.atPhysicsCriticalStrikeBaseRate = (this.sectBase.finalAttribute.atPhysicsCriticalStrike / this.constant.criticalStrikeRate * 100).toFixed(2);
            this.sectBase.finalAttribute.atPhysicsCriticalDamagePowerBaseKiloNumRate = (Number(this.sectBase.finalAttribute.atPhysicsCriticalDamagePowerBaseKiloNumRate) + (this.sectBase.finalAttribute.atPhysicsCriticalDamagePowerBase / this.constant.criticalDamagePowerRate * 100)).toFixed(2);
            this.sectBase.finalAttribute.atPhysicsOvercomePercent = (this.sectBase.finalAttribute.atPhysicsOvercomeBase / this.constant.overcomeRate * 100).toFixed(2);
            this.sectBase.finalAttribute.atStrainRate = (this.sectBase.finalAttribute.atStrainBase / this.constant.atStrainRate * 100).toFixed(2);

        },
        // 计算属性 end
    },
    mounted() {
        this.changeSect('lxg');
    }
}